function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5,8 C18.224,8 18,7.776 18,7.5 C18,7.224 18.224,7 18.5,7 C18.776,7 19,7.224 19,7.5 C19,7.776 18.776,8 18.5,8 Z M17,11.5 C17,11.776 16.776,12 16.5,12 L2.5,12 C2.224,12 2,11.776 2,11.5 L2,2.5 C2,2.224 2.224,2 2.5,2 L16.5,2 C16.776,2 17,2.224 17,2.5 L17,11.5 Z M19,0 L1,0 C0.448,0 0,0.448 0,1 L0,13 C0,13.552 0.448,14 1,14 L19,14 C19.552,14 20,13.552 20,13 L20,1 C20,0.448 19.552,0 19,0 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/tablet.53469e7e.svg";
export { SvgComponent as ReactComponent };